document.addEventListener('click', async (e) => {
  const btn = e.target.closest('#LoadMore');
  if (!btn) return;

  const container = document.querySelector('#ProductGridContainer');
  const loadMoreWrap = btn.parentElement;

  btn.disabled = true;
  btn.textContent = 'Loading…';

  try {
    const url = btn.getAttribute('data-next-url');
    const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }});
    const html = await res.text();

    // Parse the next page and extract just the product grid and the next page URL
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const nextGrid = doc.querySelector('#ProductGridContainer');
    const nextButton = doc.querySelector('#LoadMore');

    if (nextGrid && container) {
      container.insertAdjacentHTML('beforeend', nextGrid.innerHTML);
    }

    if (nextButton) {
      btn.setAttribute('data-next-url', nextButton.getAttribute('data-next-url'));
      btn.disabled = false;
      btn.textContent = 'Load more';
    } else {
      // No more pages
      loadMoreWrap.remove();
    }
  } catch (err) {
    console.error(err);
    btn.disabled = false;
    btn.textContent = 'Load more';
  }
});
